import { Paper } from "@mui/material";
import React from "react";
import SaleHistory from "./SaleHistory";
import AccountsWidget from "./AccountsWidget";

const Accounts = ({ cstmr }) => {
  return (
    <Paper className="pt-[5px] p-[15px]">
      <AccountsWidget {...{ cstmr }} />

      <div className="flex items-center mt-[30px]">
        <span
          className="text-gray-500 uppercase font-medium text-[14px] min-w-[70px]"
          style={{ minWidth: "70px" }}
        >
          History
        </span>
        <div className="border border-gray-500 w-[100%]" />
      </div>
      <div className="mt-[15px]">
        <SaleHistory {...{ cstmr }} />
      </div>
    </Paper>
  );
};

export default Accounts;
